import React, { FC, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { GenericNotification } from './GenericNotification';
import { INotification, NotificationType } from '../../../utils/hooks/useNotificator/useNotificator.types';
import { bi } from '../../../services/loggers/bi';
import { mediaManagerToastAppear } from '@wix/bi-logger-media-data/v2';

export const storagePlanUpgradedNotification = (spaceAvailable: string, isUpgradeAvailable: boolean) => {
  const PlanUpgradedNotification: FC<{ notification: INotification }> = ({ notification }) => {
    useEffect(() => {
      bi.logger().report(
        mediaManagerToastAppear({
          toastName: 'storage_upgraded',
          type: 'storage',
          upgrade_available: isUpgradeAvailable,
        }),
      );
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
      <GenericNotification
        notification={notification}
        text={<FormattedMessage id="Storage.Media_Toast_Updated_Space" values={{ remaining: spaceAvailable }} />}
        type={NotificationType.Success}
        dataHook="storagePlanUpgradeNotification"
      />
    );
  };

  return PlanUpgradedNotification;
};
